import React from 'react';

const SkipLink: React.FC = () => {
    return (
        <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-primary-600 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:bg-dark-bgSecondary dark:focus:text-primary-400"
        >
            Skip to main content
        </a>
    );
};

export default SkipLink;
